import { Button, Cell, FormControl, Grid, Icon, VFlow } from 'bold-ui'
import { CheckboxField } from 'components/form/final-form/CheckboxField'
import { ErrorField } from 'components/form/final-form/ErrorField'
import { CondutaEnum } from 'graphql/types.generated'
import React from 'react'
import { MetaPath } from 'util/metaPath'

export interface CondutaPanelProps {
  hasNotificacaoCasoSuspeito: boolean
  name: MetaPath<CondutaEnum[]>
}

export function CondutaPanel(props: CondutaPanelProps) {
  const { name, hasNotificacaoCasoSuspeito } = props

  return (
    <FormControl label='Conduta' required={!hasNotificacaoCasoSuspeito}>
      <VFlow vSpacing={0.5}>
        <ErrorField name={name} />

        <Grid gap={0} gapVertical={0.5} style={{ marginLeft: '-0.25rem' }}>
          <Cell size={6}>
            <CheckboxField
              name={name}
              label='Retorno para consulta agendada'
              value={CondutaEnum.RETORNO_PARA_CONSULTA_AGENDADA}
            />
          </Cell>
          <Cell size={6}>
            <CheckboxField
              name={name}
              label='Retorno para consulta programada / cuidado continuado'
              value={CondutaEnum.RETORNO_PARA_CUIDADO_CONTINUADO_PROGRAMADO}
            />
          </Cell>
          <Cell size={6}>
            <CheckboxField name={name} label='Agendamento para NASF' value={CondutaEnum.AGENDAMENTO_PARA_NASF} />
          </Cell>
          <Cell size={6} style={{ paddingTop: '0rem' }}>
            <CheckboxField name={name} label='Alta do episódio' value={CondutaEnum.ALTA_DO_EPISODIO} />
          </Cell>
          <Cell size={6}>
            <CheckboxField name={name} label='Agendamento para grupos' value={CondutaEnum.AGENDAMENTO_PARA_GRUPOS} />
          </Cell>
          <Cell size={6}>
            <Button kind='primary' skin='outline' size='small' onClick={(event) => {}}>
              <Icon icon='calendarOutline' /> Agendar consulta
            </Button>
          </Cell>
        </Grid>
      </VFlow>
    </FormControl>
  )
}
